var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _animateLayoutChange, _ResultsList_instances, setLayout_fn, _handleMediaQueryChange;
import { mediaQueryLarge, requestIdleCallback, startViewTransition } from "@theme/utilities";
import PaginatedList from "@theme/paginated-list";
class ResultsList extends PaginatedList {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ResultsList_instances);
    /**
     * Sets the layout.
     *
     * @param {string} value
     */
    __privateAdd(this, _animateLayoutChange, async (value) => {
      const { grid } = this.refs;
      if (!grid) return;
      const viewport = mediaQueryLarge.matches ? "desktop" : "mobile";
      await startViewTransition(() => __privateMethod(this, _ResultsList_instances, setLayout_fn).call(this, value), ["product-grid"]);
      requestIdleCallback(() => {
        try {
          sessionStorage.setItem("product-grid-view-".concat(viewport), value);
        } catch (error) {
        }
      });
    });
    /**
     * Handles the media query change event.
     *
     * @param {MediaQueryListEvent} event
     */
    __privateAdd(this, _handleMediaQueryChange, (event) => {
      const targetElement = event.matches ? this.querySelector('[data-grid-layout="desktop-default-option"]') : this.querySelector('[data-grid-layout="mobile-option"]');
      if (!(targetElement instanceof HTMLInputElement)) return;
      targetElement.checked = true;
      __privateMethod(this, _ResultsList_instances, setLayout_fn).call(this, "default");
    });
  }
  connectedCallback() {
    super.connectedCallback();
    mediaQueryLarge.addEventListener("change", __privateGet(this, _handleMediaQueryChange));
    this.setAttribute("initialized", "");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _handleMediaQueryChange));
  }
  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;
    __privateGet(this, _animateLayoutChange).call(this, target.value);
  }
}
_animateLayoutChange = new WeakMap();
_ResultsList_instances = new WeakSet();
/**
 * Animates the layout change.
 *
 * @param {string} value
 */
setLayout_fn = function(value) {
  const { grid } = this.refs;
  if (!grid) return;
  grid.setAttribute("product-grid-view", value);
};
_handleMediaQueryChange = new WeakMap();
if (!customElements.get("results-list")) {
  customElements.define("results-list", ResultsList);
}
export {
  ResultsList as default
};
